<div class="gray-bg-rounded">
  <div class="orders-list">
    <div class="d-flex align-items-center justify-content-between">
      <div class="align-items-center d-flex">
        <div class="nav-link p-0 d-flex align-items-center">
          <i class="icon-Add me-1"></i>
          <a class="link" (click)="redirectToLineItem()">Add Line</a>
        </div>

        <div class="ms-3 nav-link p-0 d-flex align-items-center">
          <i class="icon-Copy me-2"></i>
          <a class="link" (click)="showModalDialog()">Copy Line</a>
        </div>
      </div>
    </div>
    <!-- <p-table
    #dt
    [value]="cdiLinesGridListing"
    [(selection)]="selectedCDILine"
    styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg cstm-table-hover no-overfollow"
    [rowHover]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    dataKey="id"
    editMode="row"
    selectionMode="multiple"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="col-center" style="width: 3rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th class="number">#</th>
        <th class="number"></th>
        <th class="notes">Notes</th>
        <th class="vendor-sku">Vendor Sku</th>
        <th class="description">Description</th>
        <th class="unmatched">Unmatch</th>
        <th class="quantity">Quantity</th>
        <th class="net">Net</th>
        <th class="net">Net Total</th>
        <th class="net">Sell</th>
        <th class="net">Sell Total</th>
        <th class="status">Net Gp%</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-cdiLinesGridListing let-ri="rowIndex"
      let-editing="editing">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="cdiLinesGridListing"
        [pEditableRow]="cdiLinesGridListing"
        [pSelectableRow]="cdiLinesGridListing"
        (dblclick)="editLine(cdiLinesGridListing.id)"
      >
        <td class="col-center">
          <p-tableCheckbox
            [value]="cdiLinesGridListing"
            [pEditableRow]="cdiLinesGridListing"
            [pSelectableRow]="cdiLinesGridListing"
          ></p-tableCheckbox>
        </td>
        <td class="number">
          <a class="link" (click)="onLineRedirect()"> {{ cdiLinesGridListing.id }}</a>
        </td>
        
        <td style="text-align: center">
          <button
            *ngIf="!editing"
            pButton
            pRipple
            type="button"
            pInitEditableRow
            icon="pi pi-pencil"
            (click)="onRowEditInit(cdiLinesGridListing)"
            class="p-button-rounded p-button-text"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pSaveEditableRow
            icon="pi pi-check"
            (click)="onRowEditSave(cdiLinesGridListing)"
            class="p-button-rounded p-button-text p-button-success p-mr-2"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pCancelEditableRow
            icon="pi pi-times"
            (click)="onRowEditCancel(cdiLinesGridListing)"
            class="p-button-rounded p-button-text p-button-danger"
          ></button>
        </td>
        <td class="notes">
          <span class="me-1">{{ cdiLinesGridListing.notes }}</span>
          <i class="icon-Notes icon"></i>
        </td>
        <td class="status">
          {{ cdiLinesGridListing.vendorSku }}
        </td>
        <td class="description">{{ cdiLinesGridListing.description }}</td>
        
       

        <td class="number unmatch">
          <a
            class="link image-center"
            (click)="
              openUrlDialog(
                cdiLinesGridListing.poNumber
              )
            "
          >
            <span
              *ngIf="
              cdiLinesGridListing.deliverRemainderD365 !== null
                  ? cdiLinesGridListing.deliverRemainderD365 !== 0
                  : cdiLinesGridListing
                      .orderedPurchaseQuantityD365 !== 0
              "
            >
              {{
                cdiLinesGridListing.deliverRemainderD365 !== null
                  ? cdiLinesGridListing.deliverRemainderD365
                  : cdiLinesGridListing.orderedPurchaseQuantityD365
              }}
            </span>
            <i
              class="icon-BCledger"
              *ngIf="
              cdiLinesGridListing.deliverRemainderD365 !== null
                  ? cdiLinesGridListing.deliverRemainderD365 === 0
                  : cdiLinesGridListing
                      .orderedPurchaseQuantityD365 === 0
              "
            ></i>
          </a>
        </td>
        
        <td class="quantity">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="cdiLinesGridListing.qty"
              />
            </ng-template>
            <ng-template pTemplate="output">
              {{ cdiLinesGridListing.qty }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td class="net">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="cdiLinesGridListing.net"
              />
            </ng-template>
            <ng-template pTemplate="output">
              {{
                cdiLinesGridListing.net | currency: 'USD':'symbol':'0.2-2'
              }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td class="netTotal">
          {{ cdiLinesGridListing.netTotal | currency: 'USD':'symbol':'0.2-2' }}
        </td>
        
        
        <td class="sell">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="cdiLinesGridListing.sell"
              />
            </ng-template>
            <ng-template pTemplate="output">
              {{
                cdiLinesGridListing.sell | currency: 'USD':'symbol':'0.2-2'
              }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="sellTotal">
          {{ cdiLinesGridListing.sellTotal | currency: 'USD':'symbol':'0.2-2' }}
        </td>
        <td class="netGp">
          {{ cdiLinesGridListing.netGp | currency: 'USD':'symbol':'0.2-2' }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No line item found.</td>
      </tr>
    </ng-template>
  </p-table> -->
  </div>

  <jni-modal-stacker
    *ngIf="orderLineDisplayModal"
    [displayModal]="orderLineDisplayModal"
    (closeEvent)="closeModal()">
    <h1 class="panelHeading">Order Line</h1>
    <div class="panelBody">
      <jni-order-line-item
        [saleOrderIdFromModal]="OrderLineId"
        [orderLineNumberFromModal]="orderLineNumber"
        [saleOrderModalStatus]="saleOrderModalStatus"
        [isFromCdi]="true"
        [isModal]="true"
        [poNumber]="inputPoNumber"
        (closeEvent)="closeModal()"
        (scrollHiddenStatus)="addScollHiddenClass()"></jni-order-line-item>
    </div>
  </jni-modal-stacker>
</div>
